import { format } from 'date-fns';

export function formatDate(date: Date | string | null | undefined): string | null {
  const parsedDate = typeof date === 'string' ? new Date(date) : date;

  if (!parsedDate || isNaN(parsedDate.getTime())) {
    return null;
  }

  return format(parsedDate, 'yyyy-MM-dd');
}
